import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const BranchesApi = createApi({
  reducerPath: "BranchesApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["BRANCHESAPI"],
  endpoints: (build) => ({
    getBranches: build.query({
      query: ({ page }) => ({
        url: `/branches?page=${page}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BRANCHESAPI"],
    }),

    getBranchById: build.query({
      query: ({ id }) => ({
        url: `/branches/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["BRANCHESAPI"],
    }),

    editBranch: build.mutation({
      query: ({ id, data }) => ({
        url: `/branches/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["BRANCHESAPI"],
    }),

    addBranch: build.mutation({
      query: ({ data }) => ({
        url: `/branches`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["BRANCHESAPI"],
    }),

    deleteBranch: build.mutation({
      query: ({ id }) => ({
        url: `/branches/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BRANCHESAPI"],
    }),

    // Dedicated slot settings PATCH — updates only slotSettings without touching other branch fields
    updateSlotSettings: build.mutation({
      query: ({ id, data }) => ({
        url: `/branches/${id}/slot-settings`,
        method: "PATCH",
        body: data,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["BRANCHESAPI"],
    }),
  }),
});

export const {
  useGetBranchesQuery,
  useAddBranchMutation,
  useDeleteBranchMutation,
  useEditBranchMutation,
  useGetBranchByIdQuery,
  useLazyGetBranchByIdQuery,
  useUpdateSlotSettingsMutation,
} = BranchesApi;
